@use '../@shared/global' as *;
@use '../@shared/abbr.mixin' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	@include kol-abbr-styles();
}
